module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "part-no",
    attrs: {
      "id": "PT1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("PART ONE")])]), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('h1', {
    staticClass: "part-title"
  }, [_c('strong', [_vm._v("Overviews")])]), _vm._v(" "), _c('h1', {
    staticClass: "part-title1",
    attrs: {
      "id": "PT1.1"
    }
  }, [_c('strong', [_vm._v("A. Normative Overviews")])]), _vm._v(" "), _c('p', {
    staticClass: "para4"
  }, [_vm._v("Four of the eight articles in this Section are major scholarly works; they set out the basic principles that underlie all my work in the field. There are also four short pieces here, three written for scholarly outlets and one for law school alumni.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1",
    attrs: {
      "id": "PT1.1.1"
    }
  }, [_c('strong', [_vm._v("The Long …")])])]), _c('p', {
    staticClass: "para1"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#PT1.1.3"
    }
  }, [_c('em', [_vm._v("Formal, Substantive, and Disaggregated Neutrality toward Religion")]), _vm._v(" (1990)")]), _vm._v(" was the first clear development of the distinction between formal and substantive neutrality. That distinction, and that vocabulary, is now widely used in the academic community. Both conceptions of neutrality appear in Supreme Court cases, but without the vocabulary and rarely with any attention to the difference. Substantive neutrality was and is an attempt to reconcile the lawyer’s instinct for neutrality with a robust conception of religious liberty, and to escape the implication that neutrality requires that churches be regulated to the same extent as commercial businesses.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter08#PT1.1.9",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Substantive Neutrality Revisited")]), _vm._v(" (2007)")]), _vm._v(" is a more mature elaboration of the same distinction, written nearly two decades later, responding to some of the ways in which substantive neutrality had been criticized or misunderstood. This article also provided an occasion to compare my approach with those of the centrist Noah Feldman at Harvard and the strict separationist Steven Gey at Florida State.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#PT1.1.5"
    }
  }, [_c('em', [_vm._v("Religious Liberty as Liberty")]), _vm._v(" (1996)")]), _vm._v(" attempts to set out a religion-neutral case for religious liberty. We protect religious liberty not because religion is a good thing or a bad thing, but because individual liberty with respect to religious "), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("choices and commitments is a good thing. This piece also contains my most complete elaboration of why nonbelievers should be protected by the Religion Clauses.")])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _c('span', {
    attrs: {
      "href": "#/015_Chapter07a#PT1.1.8",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Theology Scholarships, the Pledge of Allegiance, and Religious Liberty")]), _vm._v(" (2004)")]), _vm._v(" is organized around two Supreme Court decisions in 2004. The Court held that Washington does not have to provide state scholarships to theology majors, and it ducked on the constitutionality of “under God” in the Pledge of Allegiance. This article places those decisions in larger context and uses them to survey the whole field, although of course the most detailed attention is devoted to the bodies of law that most directly controlled those two cases.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1",
    attrs: {
      "id": "PT1.1.2"
    }
  }, [_c('strong', [_vm._v("… and the Short")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter06#PT1.1.7",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Religious Liberty: Not for Religion or against Religion, but for Individual Choice")]), _vm._v(" (2004)")]), _vm._v(" is a 1,000-word summary of the themes in the larger pieces. There is not much detail or nuance, but if you want a five-minute introduction to what I think, this is the place to start.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter09#PT1.1.10",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Remarks on Acceptance of National Award from the Council for America’s First Freedom")]), _vm._v(" (2009)")]), _vm._v(" is even shorter and draws the moral more pointedly. We must protect the religious liberty of those we disagree with as vigorously as we would protect religious liberty for ourselves.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter05#PT1.1.6",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Free Exercise Clause and Establishment Clause: General Theories")]), _vm._v(" (2000)")]), _vm._v(" is a brief summary of all the important competing theories of the Religion Clauses. They say you can’t tell the players without a scorecard; this short encyclopedia entry offers a scorecard.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter03#PT1.1.4"
    }
  }, [_c('em', [_vm._v("The Benefits of the Establishment Clause")]), _vm._v(" (1992)")]), _vm._v(" is a talk on what the Establishment Clause adds to the Free Exercise Clause. Because of that comparative focus, and because the talk was delivered during the period of greatest concern about the Supreme Court’s contraction of the Free Exercise Clause, the talk and the questions and answers that follow the talk address both clauses.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8e2bab3a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/009_Chapter01.vue
// module id = 81
// module chunks = 0